<h3-feedback-pane
  (dialogClose)="closeAndGoBackToFeedbackList()"
  dialogTitle="Issue Feedback"
  closeButtonIcon="arrow_back"
  *ngIf="issue$ | async as issue"
>
  <div class="issue-header">
    <div class="timestamp-text body-03" *ngIf="issue.updatedAt">
      {{ issue.updatedAt | date: 'y-MMM-d h:mm a' }}
    </div>
    <div class="subtitle-03 title-container">
      <mat-icon
        class="material-symbols-outlined"
        [svgIcon]="icons[issue.type]"
      ></mat-icon>
      <span class="title-text"> {{ issue.title }}</span>
    </div>
  </div>
  <div class="popover-body" h3ScrollEnabler>
    <div class="subtitle-03 description-text">{{ issue.description }}</div>
    <mat-chip-listbox>
      <mat-chip *ngIf="issue.parkTasks" color="warn" [highlighted]="true">
        Task on hold
      </mat-chip>
      <mat-chip
        *ngFor="let tag of tags$ | async"
        color="primary"
        [highlighted]="true"
      >
        {{ tag }}
      </mat-chip>
    </mat-chip-listbox>
    <div class="screenshot-container" h3ScrollEnabler>
      <a
        [href]="screenshot.preSignedUrl"
        target="_blank"
        *ngFor="let screenshot of issue.attachments"
      >
        <img
          class="screenshot"
          [ngSrc]="screenshot.preSignedUrl"
          width="72"
          height="76"
        />
      </a>
    </div>

    <span class="caption comment-count">
      <mat-icon class="material-symbols-outlined">mode_comment</mat-icon>
      {{ issue.comments.length | i18nPlural: commentCountMapping }}
    </span>
    <div
      *ngFor="let comment of comments$ | async"
      class="comment-container"
      [class.solution]="comment.isSolution"
    >
      <div class="comment">
        <div class="comment-header-container">
          <div class="timestamp-text body-03" *ngIf="comment.createdAt">
            {{ comment.createdAt | date: 'y-MMM-d h:mm a' }}
          </div>
          <button
            mat-icon-button
            matTooltip="Mark as solution"
            *ngIf="comment.issueId && comment.id && !comment.isSolution"
            (click)="markAsSolution(comment.id, comment.issueId)"
          >
            <mat-icon svgIcon="markAsSolution"></mat-icon>
          </button>
          <div *ngIf="comment.isSolution" class="solved-marker">
            <mat-icon svgIcon="solvedMarker"></mat-icon>
            <span class="body-03">Solved</span>
          </div>
        </div>
        <div class="comment-text subtitle-03">{{ comment.text }}</div>
        <div class="screenshot-container" h3ScrollEnabler>
          <a
            [href]="screenshot.preSignedUrl"
            target="_blank"
            *ngFor="let screenshot of comment.attachments"
          >
            <img class="screenshot" [src]="screenshot.preSignedUrl" />
          </a>
        </div>
      </div>
    </div>
  </div>

  <form [formGroup]="form" class="comment-field">
    <textarea
      h3ScrollEnabler
      formControlName="comment"
      placeholder="Leave a comment"
    ></textarea>
    <div class="screenshot-container" h3ScrollEnabler>
      <img
        class="screenshot"
        [src]="screenshot.url"
        *ngFor="
          let screenshot of form.controls.screenshots.valueChanges | async
        "
      />
    </div>
    <div
      class="action-buttons"
      [class.should-show]="!!(form.controls.comment.valueChanges | async)"
    >
      <div class="add-screenshot">
        <button
          mat-button
          type="button"
          color="primary"
          (click)="fileInput.click()"
        >
          <mat-icon>crop_original</mat-icon> UPLOAD IMAGES
        </button>
        <input
          (change)="addScreenshots($event)"
          #fileInput
          type="file"
          accept="image/*"
          multiple
        />
      </div>
      <button
        mat-button
        type="button"
        color="primary"
        [disabled]="form.invalid"
        (click)="saveComment(issue.id)"
      >
        REPLY
      </button>
    </div>
  </form>
</h3-feedback-pane>
